import React, { Component } from "react";
import { Select, Form, Button, Tooltip, Icon, TreeSelect } from "antd";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";

const { Option } = Select;

export class LocationTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mainLocation: this.props.mainLocation,
      additionalLocations: this.props.additionalLocations
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeMainLocation = this.changeMainLocation.bind(this);
    this.changeAdditionalLocations = this.changeAdditionalLocations.bind(this);
    this.getTreeData = this.getTreeData.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.domain !== this.props.domain) {
      this.setState({ mainLocation: this.props.mainLocation, additionalLocations: this.props.additionalLocations });
    }
  }

  getTreeData() {
    let additionalLocationsOrder = this.props.locationsOrder.filter(location => location !== this.state.mainLocation);
    return additionalLocationsOrder.map(regionCode => ({
      title: this.props.locations[regionCode],
      value: regionCode,
      key: regionCode,
      selectable: true,
      disabled:
        this.state.additionalLocations.length === this.props.maxRegionsNo - 1 &&
        !this.state.additionalLocations.includes(regionCode),
      isLeaf: true
    }));
  }

  changeMainLocation(value) {
    this.setState({ mainLocation: value, additionalLocations: [] });
  }

  changeAdditionalLocations(value) {
    this.setState({ additionalLocations: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    let locationsList = [this.state.mainLocation, ...this.state.additionalLocations];
    let settings = { regions: locationsList };
    this.props.updateLocations(this.props.domain, settings, "changeLocations");
  }

  render() {
    const tProps = {
      allowClear: true,
      treeData: this.getTreeData(),
      value: this.state.additionalLocations,
      onChange: this.changeAdditionalLocations,
      treeCheckable: true,
      multiple: true,
      treeDefaultExpandAll: true,
      searchPlaceholder: "Select additional regions",
      dropdownStyle: {
        maxHeight: 400,
        overflow: "auto"
      },
      maxTagCount: this.props.maxRegionsNo - 1,
      filterTreeNode: true,
      treeNodeFilterProp: "title"
    };

    return (
      <div className="location-tab">
        {!this.props.isLoading ? (
          <Form onSubmit={this.handleSubmit}>
            <Form.Item
              colon={false}
              className="normal-line-height"
              label={
                <React.Fragment>
                  <p>
                    <strong>Primary monitor locations &nbsp;</strong>
                    <Tooltip
                      placement="right"
                      title={"Please select the primary location from where we'll monitor your site's loading speed."}>
                      <Icon type="question-circle" />
                    </Tooltip>
                  </p>
                </React.Fragment>
              }>
              <Select value={this.state.mainLocation} onChange={this.changeMainLocation}>
                {this.props.locationsOrder.map(regionCode => (
                  <Option value={regionCode} key={regionCode}>
                    {this.props.locations[regionCode]}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {this.props.maxRegionsNo > 1 ? (
              <Form.Item
                className="normal-line-height"
                colon={false}
                label={
                  <React.Fragment>
                    <p>
                      <strong>Additional monitor locations &nbsp;</strong>
                      <Tooltip
                        placement="right"
                        title={`Please select ${this.props.maxRegionsNo -
                          1} additional regions from where we'll monitor your site's loading speed`}>
                        <Icon type="question-circle" />
                      </Tooltip>
                    </p>
                  </React.Fragment>
                }>
                <TreeSelect {...tProps} />
              </Form.Item>
            ) : null}

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={this.props.isUpdatingLocations}>
                Update
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <LoadingIndicator />
        )}
      </div>
    );
  }
}

export default LocationTab;
